import {
  Skeleton as MuiSkeleton,
  SkeletonProps as MuiSkeletonProps,
} from '@mui/material';

type SkeletonProps = {
  width?: number | string | Record<string, number | string>;
  height?: number | string | Record<string, number | string>;
} & Omit<MuiSkeletonProps, 'width' | 'height'>;

export const Skeleton = ({
  variant = 'text',
  width = '100%',
  height = '100%',
  animation = 'wave',
  sx,
  ...rest
}: SkeletonProps) => (
  <MuiSkeleton
    animation={animation}
    sx={{ bgcolor: 'grey50', width, height, ...sx }}
    variant={variant}
    {...rest}
  />
);
